// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recently-issued-card-container {
  padding: 36px 20px 80px;
}
@media screen and (min-width: 768px) {
  .recently-issued-card-container {
    padding: 95px 20px 199px;
  }
}
.recently-issued-card-container .table-container {
  margin-top: 5rem;
}
.recently-issued-card-container .heading-container p {
  margin-top: 7px;
}
.recently-issued-card-container .heading-container {
  margin-bottom: 42px;
}
@media screen and (min-width: 768px) {
  .recently-issued-card-container .heading-container {
    margin-bottom: 49px;
  }
}

.table-filter-body .form-container .field-container {
  margin: 23px 0;
}
.table-filter-body .form-container .field-container .MuiFormControl-root.form-control {
  width: 100% !important;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .field-container .MuiFormControl-root.form-control {
    width: 50% !important;
  }
}
.table-filter-body .form-container .field-container .MuiFormControl-root.form-control:first-child {
  margin-right: 0;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .field-container .MuiFormControl-root.form-control:first-child {
    margin-right: 24px;
    width: calc(50% - 24px) !important;
  }
}
.table-filter-body .form-container .field-button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.table-filter-body .form-container .field-button-container .date-container {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .field-button-container .date-container {
    width: calc(50% - 24px);
    margin-right: 24px;
  }
}
.table-filter-body .form-container .field-button-container .date-container span {
  color: white;
  width: 100px;
  font-size: 19px;
}
.table-filter-body .form-container .field-button-container .date-container .date-picker-field {
  background-color: black;
  border: none;
  border-bottom: 1px solid white;
  min-width: 240px;
  width: 100%;
  color: white;
}
.table-filter-body .form-container .field-button-container .buttons {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .field-button-container .buttons {
    width: 50%;
  }
}
.table-filter-body .form-container .field-button-container .buttons button {
  margin: 15px 7px;
  width: 100%;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .field-button-container .buttons button {
    width: calc(33.33% - 14px);
    margin-top: 0px;
  }
}

.table-loading {
  font-size: 30px !important;
  padding: 30px;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/issue-card-table/IssueCardTable.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;AAAE;EAFF;IAGI,wBAAA;EAGF;AACF;AAFE;EACE,gBAAA;AAIJ;AADI;EACE,eAAA;AAGN;AALE;EAIE,mBAAA;AAIJ;AAHI;EALF;IAMI,mBAAA;EAMJ;AACF;;AADI;EACE,cAAA;AAIN;AAHM;EACE,sBAAA;AAKR;AAJQ;EAFF;IAGI,qBAAA;EAOR;AACF;AANQ;EACE,eAAA;AAQV;AAPU;EAFF;IAGI,kBAAA;IACA,kCAAA;EAUV;AACF;AADI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;AAGN;AADM;EACE,WAAA;AAGR;AAFQ;EAFF;IAGI,uBAAA;IACA,kBAAA;EAKR;AACF;AAJQ;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAMV;AAJQ;EACE,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAMV;AAHM;EACE,WAAA;AAKR;AAJQ;EAFF;IAGI,UAAA;EAOR;AACF;AANQ;EACE,gBAAA;EACA,WAAA;AAQV;AAPU;EAHF;IAII,0BAAA;IACA,eAAA;EAUV;AACF;;AAHA;EACE,0BAAA;EACA,aAAA;EACA,WAAA;AAMF","sourcesContent":[".recently-issued-card-container {\n  padding: 36px 20px 80px;\n  @media screen and (min-width: 768px) {\n    padding: 95px 20px 199px;\n  }\n  & .table-container {\n    margin-top: 5rem;\n  }\n  .heading-container{\n    p{\n      margin-top: 7px;\n    }\n    margin-bottom: 42px;\n    @media screen and (min-width: 768px) {\n      margin-bottom: 49px;\n  }\n  }\n}\n.table-filter-body {\n  .form-container {\n    .field-container {\n      margin: 23px 0;\n      .MuiFormControl-root.form-control{\n        width: 100% !important;\n        @media screen and (min-width: 768px) {\n          width: 50% !important;\n        }\n        &:first-child {\n          margin-right: 0;\n          @media screen and (min-width: 768px) {\n            margin-right: 24px;\n            width: calc( 50% - 24px ) !important;\n          }\n        }\n      }\n      // .form-control {\n      //   &.w-50 {\n      //     width: 50% !important;\n      //   }\n      // }\n    }\n    .field-button-container {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      // margin-left: 8px;\n      .date-container {\n        width: 100%;\n        @media screen and (min-width: 768px) {\n          width: calc( 50% - 24px );\n          margin-right: 24px;\n        }\n        span {\n          color: white;\n          width: 100px;\n          font-size: 19px;\n        }\n        .date-picker-field {\n          background-color: black;\n          border: none;\n          border-bottom: 1px solid white;\n          min-width: 240px;\n          width: 100%;\n          color: white;\n        }\n      }\n      .buttons{\n        width: 100%;\n        @media screen and (min-width: 768px) {\n          width: 50%;\n        }\n        button{\n          margin: 15px 7px;\n          width: 100%;\n          @media screen and (min-width: 768px) {\n            width: calc( 33.33% - 14px );\n            margin-top: 0px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.table-loading {\n  font-size: 30px !important;\n  padding: 30px;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
